import React, {FC} from 'react'
import {IProductProps, productActionType} from '../../cors/reducers'
import InputField from '../../components/InputField'
import {useIntl} from 'react-intl'

// Company Code was removed from the UI (the supplier can't edit it here). Its
// value still lives in prodState.companyCode — loaded from product_info and
// sent on save — so the existing company code is preserved; only the input is
// gone. Model is now full-width, on the clean aps- layout (no bordered card).
const BarcodeCompany: FC<IProductProps> = ({prodState, prodDispatch}) => {
  const {formatMessage} = useIntl()

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {id, value} = e.target
    prodDispatch({type: productActionType.text, payload: {id, value}})
  }

  return (
    <InputField
      hasError={prodState.model.error}
      value={prodState.model.value}
      onChange={handleChange}
      id='model'
      label={formatMessage({id: 'model_number'})}
      isRequired={true}
    />
  )
}

export default BarcodeCompany
